import React, { Component } from "react"
import PropTypes from "prop-types"

import { locales } from "../../../locales"
import Bouton from "../boutons/Bouton"
import {
  classeCSSSnipcartAjoutItemAuPanier,
  decorerBoutonAcheterAvecAttributsSnipcart,
} from "../../js/client-es/snipcart"
import { objetEstDefini } from "../../js/client-es/utils"

export default class BoutonAcheterTirage extends Component {
  constructor(props) {
    super(props)
    this.langue = props.langue
    this.image = props.image
    this.refBouton = React.createRef()
  }

  render() {
    return (
      <Bouton
        id="btn-acheter-tirage"
        reference={this.refBouton}
        texte={locales[this.langue].boutique.ajouterAuPanier}
        classeCSS={
          "bouton boutique-bouton-ajouter-panier " +
          classeCSSSnipcartAjoutItemAuPanier()
        }
        attributs={decorerBoutonAcheterAvecAttributsSnipcart(
          this.image,
          this.langue,
          this.props.prestations,
          this.props.finition
        )}
        type="submit"
        fonctionAAppeler={this.retirerClasseSnipcartSiFinitionNonRenseignee.bind(
          this
        )}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 0 24 24"
          width="24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
        </svg>
      </Bouton>
    )
  }

  retirerClasseSnipcartSiFinitionNonRenseignee() {
    /*Par défaut, il faut que la classe snipcart-add-item soit présente sur le bouton pour que
    me mécanisme de contrôle "anti fraude" de snipcart fonctionne bien : https://docs.snipcart.com/v3/setup/order-validation
    Si la finition n'est pas renseignée, on retire la classe du bouton pour éviter que le panier ne s'ouvre.*/
    if (
      objetEstDefini(this.refBouton) &&
      !objetEstDefini(this.props.finition)
    ) {
      this.refBouton.current.className =
        "bouton boutique-bouton-ajouter-panier "
    } else if (objetEstDefini(this.refBouton))
      this.refBouton.current.className =
        "bouton boutique-bouton-ajouter-panier " +
        classeCSSSnipcartAjoutItemAuPanier()
  }
}

BoutonAcheterTirage.propTypes = {
  image: PropTypes.object,
  langue: PropTypes.string,
  prestations: PropTypes.object,
  finition: PropTypes.object,
}
